export default __webpack_public_path__ + "img/d19f1965d3fe108801c85653ad635d74.svg";